import slugify from "slugify";
import dollar from "../../assets/stockPhotos/r1_c1.jpg";
import { textClip, useVolumeInfo, formatVolumeIssueShort } from "../../utils";
import { PDFButtonSmall } from "../utils";
import CardButton from "./CardButton";
import CardCover from "./CardCover";

function ArticleCardFullWidth(props) {
  const { coverPhoto, author, volume, title, slug, pdf } = props;

  const { cname, id, path } = props;
  const volumeInfo = useVolumeInfo(volume);
  const authorText = `BY ${textClip(
    author.toUpperCase(),
    65
  )} ${String.fromCharCode(183)} ${formatVolumeIssueShort(volumeInfo).toUpperCase()}`;
  const defaultPhoto = coverPhoto ? coverPhoto : dollar;
  return (
    <div
      className={`rounded-md overflow-hidden
       shadow-lg my-4 md:m-4 lg:h-auto
       md:col-span-full`}
    >
      <CardCover coverPhoto={defaultPhoto} authorText={authorText} />
      <CardContent
        title={title}
        slug={slug}
        id={id}
        path={path}
        cname={cname}
        pdf={pdf}
      />
    </div>
  );
}

function CardContent({ title, slug, id, path, cname, pdf }) {
  const aboutSlug = textClip(slug, 400);
  const urlSlug = slugify(title);

  return (
    <div className="mx-2 my-4 text-justify md:mx-6 border-gray-light">
      <div
        className="h-16 text-lg font-bold text-left text-gray-600 overflow-hidden md:mb-4 md:text-2xl"
        style={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
        }}
        title={title}
      >
        {title}
      </div>
      <p className="px-2 mb-8 font-normal text-gray-700 break-words text-md lg:mb-0 lg:h-28">
        {aboutSlug}
      </p>
      <div className={`flex flex-wrap items-center content-evenly ${cname.button || ''}`}>
        <CardButton
          text="Read More"
          slug={urlSlug}
          id={id}
          path={path}
        />
        <PDFButtonSmall pdfLink={pdf} articleId={id} />
      </div>
    </div>
  );
}

export default ArticleCardFullWidth;
